import { staticUserForm } from 'pages/authentication/sign-up/update-session-storage';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

const NON_SESSION_SPECIFIC_STORAGE_KEYS = [
  SyncStorageKey.HAS_MIGRATED_FROM_ASYNC_STORAGE,
  SyncStorageKey.HAS_MIGRATED_FROM_CAPACITOR_STORAGE,
  SyncStorageKey.COMPLETED_USER_JOURNEY_FIELDS,
  SyncStorageKey.COMPLETED_USER_JOURNEY_SEEN,
  SyncStorageKey.LAST_SEEN_LOYALTY_POINTS,
  SyncStorageKey.LOYALTY_ONBOARDING_SEEN,
  SyncStorageKey.INTERNAL_BUILD_ONLY_ENV_PICKER_CONFIG,
  SyncStorageKey.LANGUAGE,
  SyncStorageKey.READ_CONTENT_CARDS,
  SyncStorageKey.ONBOARDING_DATA_SENT,
  SyncStorageKey.ONBOARDING_STATE,
];

const USER_STATE_CLEANUP_PRESERVED_STORAGE_KEYS = [
  ...NON_SESSION_SPECIFIC_STORAGE_KEYS,
  // Credential commits happen before cleanup. Preserve the incoming marker; guest commits and
  // invalidated restoration remove it in the Cognito adapter before this cleanup runs.
  SyncStorageKey.USER_ID,
];

export const clearRetiredUserStorage = () => {
  staticUserForm.current = null;
  syncStorage.clearAllExcept(USER_STATE_CLEANUP_PRESERVED_STORAGE_KEYS);
};
